import { TitlePlaceholderLoader } from "@similarweb/ui-components";
import { StyledListItem, StyledLoaderWrapper, StyledPixelLoader } from "./styles";

type Props = {
    itemsCount: number;
};

const SignalsListLoader = ({ itemsCount }: Props) => {
    return (
        <StyledLoaderWrapper>
            {Array.from({ length: itemsCount }, (_, index) => (
                <StyledListItem key={index}>
                    <StyledPixelLoader
                        width={25}
                        height={25}
                    />
                    <TitlePlaceholderLoader />
                </StyledListItem>
            ))}
        </StyledLoaderWrapper>
    );
};

export default SignalsListLoader;
